import React from 'react'
import styled from 'styled-components'

const InnerView = styled.div`
  box-sizing: border-box;
`

export const View = ({ children, ...props }) => <InnerView {...props}>{children}</InnerView>
